import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import { useViewSegmentView } from "../ViewSegment.context";

export function useViewSegmentContent() {
  const { mdUp } = useBreakpoints();

  const { segmentId } = useViewSegmentView();

  return { segmentId, mdUp };
}
